import { EnumLiteralsOf } from 'utilities';

export const popupSelectorTypes = {
  addProduct: 'addProduct' as 'addProduct',
  addPerson: 'addPerson' as 'addPerson'
};
export type PopupSelectorTypes = EnumLiteralsOf<typeof popupSelectorTypes>;